import { Assets } from 'pixi.js';
import { GameApp } from './GameApp.js';
import { applyLaunchLayout } from './config/gameConfig.js';
import { resolveGameVariant } from './config/gameVariants.js';
import { getParamsFromUrl } from './features/i18n/loadTranslations.js';
import { setTranslationCulture, setTranslationVariant } from './features/i18n/translationStore.js';
import { patchPixiAssetLoader } from './utils/assetUrl.js';

patchPixiAssetLoader(Assets);

/** Apply 5×4 layout before any reel UI is built (40-line and 100-line launches). */
const launchParams = getParamsFromUrl(window.location.search);
const launchVariant = resolveGameVariant(launchParams.GameName);
applyLaunchLayout(launchVariant);
setTranslationVariant({ lines40: launchVariant.lines40, lines100: launchVariant.lines100 });
setTranslationCulture(launchParams.Culture ?? launchParams.culture ?? 'en');

/**
 * Wrapped in an async IIFE instead of using top-level `await`.
 * Top-level await requires Safari 15+ / iOS 15+ / Chrome 89+, so emitting it
 * makes the entire module fail to parse on iOS 12–14 and old Android WebView.
 * The build target (see `vite.config.js`) is also lowered so syntax like `?.`
 * and `??` is transpiled for these same browsers.
 */
(async () => {
  try {
    const game = new GameApp();
    await game.init(document.body);
  } catch (err) {
    console.error(err);
  }
})();
